import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getOffset = (state: RootState) => state.pages.editor.canvas.offset;

const getCanvasOffset = createSelector([getOffset], (offset) => offset);

export default getCanvasOffset;
